import styled from 'styled-components'
import { colorConstants } from '@jarvis.oddle/core/theme/default'
import Image from '@jarvis.oddle/core/components/Image'

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  background: transparent;

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }

  .lazyload {
    opacity: 0;
  }

  .lazyloading {
    opacity: 1;
    background: ${colorConstants.lightGray};
  }
`

export const ProductImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 300ms ease-in-out;
`
